import { FormattedMessage } from '@99designs/common/i18n';
import React from 'react';

const LocalTime = ({ utcOffset }: { utcOffset: string }) => {
    if (!utcOffset) {
        return null;
    }

    // Get current UTC time
    const now = new Date();
    const utc = now.getTime() + now.getTimezoneOffset() * 60000;

    // Adjust time with UTC offset e.g. "+1000", "-0700"
    const utcOffsetMilliseconds = parseFloat(utcOffset) * 36000;
    const localDate = new Date(utc + utcOffsetMilliseconds);

    const time = localDate.toLocaleTimeString('default', {
        hour: 'numeric',
        minute: 'numeric',
        hour12: true,
    });

    return (
        <div className="designer-meta__local-time">
            <FormattedMessage message={__(`Local time: {time}`)} values={{ time }} />
        </div>
    );
};

export default LocalTime;
